import { useTranslation } from "react-i18next";
import { Grid, GridColumn } from "semantic-ui-react";

import { Dropdown, ResetFiltersButton } from "components";
import { EXACT_CATEGORIES } from "models";
import {
  IGNORED_FILTER_OPTIONS,
  setUnlinkedLicensesFilters,
  useGetUnlinkedLicensesFilters,
  useIgnoredOptions
} from "modules/UnlinkedExactLicensesDashboard/components/UnlinkedExactLicensesFilters/hooks";
import "modules/UnlinkedExactLicensesDashboard/components/UnlinkedExactLicensesFilters/UnlinkedExactLicensesFilters.scss";
import { UNLINKED_EXACT_LICENSES_STORAGE_KEYS } from "modules/UnlinkedExactLicensesDashboard/storageKeys";
import { enumToDropdownOptions, setPreference } from "utils/common";

const getIgnoredFiltersDropdownValue = (ignored: boolean | null) => {
  if (ignored === false) return IGNORED_FILTER_OPTIONS.HideIgnored;
  if (ignored === true) return IGNORED_FILTER_OPTIONS.HideUnignored;
  return IGNORED_FILTER_OPTIONS.ShowAll;
};

const getIgnoredFiltersFilterValue = (option: IGNORED_FILTER_OPTIONS) => {
  switch (option) {
    case IGNORED_FILTER_OPTIONS.HideIgnored:
      return false;
    case IGNORED_FILTER_OPTIONS.HideUnignored:
      return true;
    case IGNORED_FILTER_OPTIONS.ShowAll:
    default:
      return null;
  }
};

export const UnlinkedExactLicensesFilters = () => {
  const { t } = useTranslation();

  const ignoredOptions = useIgnoredOptions();
  const filters = useGetUnlinkedLicensesFilters();

  const handleCategoryChange = (category: number[]) => {
    setPreference(UNLINKED_EXACT_LICENSES_STORAGE_KEYS.ExactCategoryTypesPreference, category);
    setUnlinkedLicensesFilters({ ...filters, exact_category_types: category });
  };

  const handleIgnoreStatusChange = (ignoredFilter?: IGNORED_FILTER_OPTIONS) => {
    if (!ignoredFilter) return;
    const filterValue = getIgnoredFiltersFilterValue(ignoredFilter);

    setPreference(UNLINKED_EXACT_LICENSES_STORAGE_KEYS.IgnoredUnlinkedExactLicensesPreference, filterValue);
    setUnlinkedLicensesFilters({ ...filters, ignored: filterValue });
  };

  const handleResetFilters = () => {
    setPreference(UNLINKED_EXACT_LICENSES_STORAGE_KEYS.IgnoredUnlinkedExactLicensesPreference, false);
    setPreference(UNLINKED_EXACT_LICENSES_STORAGE_KEYS.ExactCategoryTypesPreference, null);
    setUnlinkedLicensesFilters({ ignored: false, exact_category_types: [] });
  };

  return (
    <div className="UnlinkedExactLicensesFilters">
      <Grid className="UnlinkedExactLicensesFilters__container">
        <GridColumn width={6} className="UnlinkedExactLicensesFilters__ignored">
          <Dropdown
            fluid
            selection
            name="ignored"
            value={getIgnoredFiltersDropdownValue(filters.ignored)}
            selectOnBlur={false}
            options={ignoredOptions}
            onChange={handleIgnoreStatusChange}
          />
        </GridColumn>

        <GridColumn width={10} className="UnlinkedExactLicensesFilters__category">
          <Dropdown
            fluid
            selection
            name="filterByCategory"
            clearable
            multiple
            value={filters.exact_category_types}
            options={enumToDropdownOptions({ enumObj: EXACT_CATEGORIES, t })}
            placeholder={t("v8_filter_role_license_service", "Filter Role / License / Service")}
            onChange={handleCategoryChange}
          />
          <ResetFiltersButton handleReset={handleResetFilters} />
        </GridColumn>
      </Grid>
    </div>
  );
};
